"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noop = noop;
exports.intBetween = intBetween;
function noop() {}

function intBetween(min, max, val) {
  return Math.floor(Math.min(max, Math.max(min, val)));
}


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd-scrollzone/lib/util.js
// module id = 228
// module chunks = 0